/**
 * Utility for concatenating classnames conditionally
 * Similar to clsx but simpler implementation
 */
export function cn(...inputs: (string | boolean | undefined | null)[]): string {
  return inputs
    .filter(Boolean)
    .join(' ')
    .trim();
}